import { useState } from 'react';

import axios from 'axios';

import { useAxiosRequest } from './use_axios_request';

type MessageStats = {
  count: number;
};

export const useMessageStatsRequest = () => {
  const [request] = useState(() => axios.get<MessageStats>('/message_stats.json'));
  return useAxiosRequest(request);
};
